import {
  ConsumerExploreDishFirstQuery,
  DishFirstFoodItemsSegmentFragment,
  DishFirstSegmentFilter,
} from 'src/gqlReactTypings.generated.d';
import { match } from 'ts-pattern';
import { useAllCuisinesShowing } from '../store';

export const TOP_TWO_CUISINES = [`${DishFirstSegmentFilter.Indian}`, `${DishFirstSegmentFilter.SoutheastAsian}`];

export const usePageSegments = (data?: ConsumerExploreDishFirstQuery, overrideSeeAll = false) => {
  const { isAllCuisinesShowing } = useAllCuisinesShowing();
  const seeAll = overrideSeeAll || isAllCuisinesShowing;

  const filteredExploreFoodItems = data?.exploreFoodItems
    ? data.exploreFoodItems.filter(
        (foodItem, index, self) => index === self.findIndex((exploreFoodItem) => foodItem.id === exploreFoodItem.id)
      )
    : data?.exploreFoodItems;

  const lastIndexOfTopCuisine = filteredExploreFoodItems
    ? filteredExploreFoodItems
        .map((element, rowNumber) =>
          match(element)
            .with({ __typename: 'ExploreFoodItemsSegment' }, (segment: DishFirstFoodItemsSegmentFragment) =>
              TOP_TWO_CUISINES.includes(segment.id) ? rowNumber : -1
            )
            .otherwise(() => -1)
        )
        .filter((index) => index !== -1)
        .slice(-1)[0] || filteredExploreFoodItems.length - 1
    : -1;

  const exploreFoodItemsTopCuisines = filteredExploreFoodItems
    ? filteredExploreFoodItems.slice(0, lastIndexOfTopCuisine + 2)
    : data?.exploreFoodItems;

  const exploreFoodItems = !seeAll ? exploreFoodItemsTopCuisines : filteredExploreFoodItems;
  const seeAllCuisinesIndex = exploreFoodItemsTopCuisines
    ? exploreFoodItemsTopCuisines.length
    : data?.exploreFoodItems.length;

  return exploreFoodItems
    ? { data: { ...data, exploreFoodItems }, seeAllCuisinesIndex: lastIndexOfTopCuisine + 1 }
    : { data, seeAllCuisinesIndex: seeAllCuisinesIndex ? seeAllCuisinesIndex + 1 : 98 };
};
